import React, { forwardRef } from 'react';
import styles from './InputCheckbox.module.scss';

interface IInputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  labelText?: string;
  error?: boolean;
  className?: string;
  tabIndex?: number;
  toggler?: boolean;
}

/**
 * General and reusable component. Should be used for checkboxes
 * @param name - name for the checkbox.
 * @param labelText - label text for the input.
 * @param error - Indicates error for the checkbox
 * @param className - string
 * @param toggler - Indicates whether the checkbox is selected
 * @returns A checkbox element representing the checkbox.
 */

const InputCheckbox = forwardRef<any, IInputFieldProps>((props, ref) => {
  const { className, error, labelText, toggler, ...rest } = props;

  return (
    <label
      className={[
        styles.checkboxlabel,
        toggler && styles.switch,
        error && styles.error,
      ].join(' ')}
    >
      <input
        type="checkbox"
        ref={ref}
        className={[className].join(' ')}
        {...rest}
      />
      {toggler ? (
        <span className={[styles.slider, styles.round].join(' ')} />
      ) : (
        <span className={styles.checkmark} />
      )}
      {labelText && <p>{labelText}</p>}
    </label>
  );
});

export default InputCheckbox;
